import styled, { css } from 'styled-components';
import { fontStyle } from '@whitelabel/helpers/style/type';
import { mediaBreakpointUp } from '@whitelabel/helpers/style/grid';
import { ContentBlock } from '@whitelabel/component-library';

const StyledSmallContentBlock = styled(ContentBlock)<{
  $rtl: boolean;
  $noMarginBottom?: boolean;
  $useInheritedColour?: boolean;
}>`
  ${({ $noMarginBottom }) =>
    !$noMarginBottom &&
    css`
      margin-bottom: 1rem;

      ${mediaBreakpointUp('md')`
      margin-bottom: 2rem;
    `};
      ${mediaBreakpointUp('lg')`
      margin-bottom: 3rem;
    `};
    `}

  /* There is some padding applied to an element inside ContentBlock which is not needed here */
  .container {
    padding: 0;
  }

  ul li a {
    ${fontStyle('accordionHeader')}
  }

  p,
  li {
    color: ${({ $useInheritedColour, theme }) => ($useInheritedColour ? 'inherit' : theme.themeColors.body)};
    font-size: 1.125rem;
  }

  /* Chris' request for article page [start] */
  .heading-block,
  .heading-block h2,
  .heading-block h3,
  .heading-block h4,
  .heading-block h5,
  .heading-block h6 {
    margin-bottom: 0.5rem;
    ${mediaBreakpointUp('lg')`
      margin-bottom: 1rem;
    `};
  }
  .rich-text-block,
  .heading-block {
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 &&& {
      font-weight: 500;
      line-height: 1.25;
      text-transform: none;
    }
    h1 {
      font-size: 1.5rem;
      ${mediaBreakpointUp('md')`
      font-size: 2rem;
    `};
      ${mediaBreakpointUp('lg')`
      font-size: 2.5rem;
    `};
    }
    h2 {
      font-size: 1.25rem;
      ${mediaBreakpointUp('md')`
      font-size: 1.5rem;
    `};
      ${mediaBreakpointUp('lg')`
      font-size: 1.75rem;
    `};
    }
    h3 {
      font-size: 1.125rem;
      ${mediaBreakpointUp('md')`
      font-size: 1.25rem;
    `};
      ${mediaBreakpointUp('lg')`
      font-size: 1.5rem;
    `};
    }
    h4 {
      font-size: 1rem;
      ${mediaBreakpointUp('md')`
      font-size: 1.125rem;
    `};
      ${mediaBreakpointUp('lg')`
      font-size: 1.25rem;
    `};
    }

    h3,
    h4 {
      margin-top: 1rem;
      ${mediaBreakpointUp('lg')`
      margin-top: 1.5rem;
    `};
    }
  }

  .rich-text-block,
  .list-block {
    li {
      margin-bottom: 0.5rem;
    }
  }

  li:last-child {
    margin-bottom: 0;
  }

  .section-block {
    margin-bottom: 1rem;
    ${mediaBreakpointUp('md')`
      margin-bottom: 2rem;
    `};
    ${mediaBreakpointUp('lg')`
      margin-bottom: 3rem;
    `};

    :last-child {
      margin-bottom: 0;
    }
  }

  /* Chris' request for article page [end] */
`;

export default StyledSmallContentBlock;
